import axios from 'axios';
import { apiProfilesUserPasswordUrl } from '../config';

/**
 * Change User Password.
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props - properties Object
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {string} [props.confirmedPassword] - confirmed password
 * @param {string} [props.currentPassword] - current Password
 * @param {string} [props.newPassword] - new password
 * @param {string} [props.token] - use token instead of current password
 * @returns {Promise}
 */
const putUserPassword = props => {
  const {
    confirmedPassword,
    currentPassword,
    newPassword,
    requestConfig,
    token
  } = props;

  if (!newPassword || !confirmedPassword) {
    return Promise.reject(
      new Error(
        'You need to pass `newPassword` and `confirmedPassword` as props'
      )
    );
  }

  const method = 'put';
  const url = apiProfilesUserPasswordUrl;
  const data = { confirmedPassword, currentPassword, newPassword, token };

  return axios({
    data,
    method,
    url,
    ...requestConfig
  });
};

export default putUserPassword;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/putUserPassword.js